import React from 'react';

import { useParams } from 'react-router-dom';

import { Alert, CircularProgress } from '@mui/material';

import RoomPolicyForm from '~/components/Common/Forms/RoomPolicyForm';

import { useGetRoomPolicySchema } from '~/hooks/apis/offers/useGetOffer';

import type { RoomPolicy } from '~/types/roomPolicy';

interface Props {
  offerType?: string;
  onRoomPolicyChange?: (roomPolicy: RoomPolicy) => void;
  roomPolicy?: RoomPolicy;
}

export default function PoliciesTab({ offerType, onRoomPolicyChange, roomPolicy }: Props) {
  const { id_offer: offerId } = useParams<{ id_offer: string }>();
  const { data: schema, error: schemaError, isLoading: isLoadingSchema } = useGetRoomPolicySchema(offerId);

  if (isLoadingSchema) {
    return <CircularProgress size={24} />;
  }

  if (schemaError || !schema) {
    return <Alert severity="error">Unable to load room policy schema.</Alert>;
  }

  if (!roomPolicy) {
    return <Alert severity="info">This room is not attached to a package with room policies.</Alert>;
  }

  return (
    <RoomPolicyForm
      hideSaveButton
      schema={schema}
      roomPolicy={roomPolicy}
      idOffer={offerId}
      offerType={offerType ?? ''}
      onRoomPolicyChange={onRoomPolicyChange}
    />
  );
}
